module.exports = __webpack_public_path__ + "img/Logo QUIETSEAS_w.88e35534.png";